const Spacer: React.FC = () => <div className="Spacer" style={{flex: 1}} />;
export default Spacer;
